module.exports = __webpack_public_path__ + "static/img/GA.33dc2392.png";